import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.AKnJ0PxmEnSO2wSQvX2jfAPU-7RGjAKFsOSdEliyQGrJI3CScAfjZfPj-U6k-StzdKMAMm32o9lOK3oGZsRFE6qcmPc91ETIYsQ1WTlkxCgldFBcb8Wq6hIcQyQGCPMbWEuoxCvTMI1UYrkWZMf6R2VuaC6v867RzUqE4BjYMntyTc1qNeKaIT5nh-1ZJSe0-ibXF8lm_vCE9xo92xQ98ePPPTCEZHUDjRa9PgJSHV1rCyBTIHUAJNo2dWZfkhPOeHY1qfxtbS7IzGC9pguJHF9S6yYSB6KdMnBRB3gXvty1m60p4vcVHrmI0QALkz7tGLv-9cRsiYd0yXDO8rQlBeAMw-5a4Yd42A",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-05-07T17:22:17.662842Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.AKnJ0PxmEnSO2wSQvX2jfAPU-7RGjAKFsOSdEliyQGrJI3CScAfjZfPj-U6k-StzdKMAMm32o9lOK3oGZsRFE6qcmPc91ETIYsQ1WTlkxCgldFBcb8Wq6hIcQyQGCPMbWEuoxCvTMI1UYrkWZMf6R2VuaC6v867RzUqE4BjYMntyTc1qNeKaIT5nh-1ZJSe0-ibXF8lm_vCE9xo92xQ98ePPPTCEZHUDjRa9PgJSHV1rCyBTIHUAJNo2dWZfkhPOeHY1qfxtbS7IzGC9pguJHF9S6yYSB6KdMnBRB3gXvty1m60p4vcVHrmI0QALkz7tGLv-9cRsiYd0yXDO8rQlBeAMw-5a4Yd42A'

// {
//   "access_token": "v2.local.xUjuf2CeCDd0P3gbC6SgvfzY6xkT8s0cFND-KXLI8zl7N1EwyEZppbGBhpoI42OpdLJfgZgKsWut__smqh0V5OJDfmf7_k0sRASk07lJJ79ifPAAgeh7hvp1JNZJYvNXd51PCPczUBs7Qr5DwPPWZiQ5xhfCEYgiupq3UWTi_-AIUi4b5yFdgW-kQ9qG7o-rlMfwrwzxbcSJXMt15fdbNmgHH4TETywWxGM3uMf-tb9QROi8PPWoVCM3cTrymnWmzqppcvO_yczYqaLJ2JkBFuAAgp7ahM8dKUzlmiU3vLpvCPuXcLXOpQZPm4WCaVlZ5T8QztTa9qdFKHAVnv_opVulZQnE",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-05-07T17:18:27.421225Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.xUjuf2CeCDd0P3gbC6SgvfzY6xkT8s0cFND-KXLI8zl7N1EwyEZppbGBhpoI42OpdLJfgZgKsWut__smqh0V5OJDfmf7_k0sRASk07lJJ79ifPAAgeh7hvp1JNZJYvNXd51PCPczUBs7Qr5DwPPWZiQ5xhfCEYgiupq3UWTi_-AIUi4b5yFdgW-kQ9qG7o-rlMfwrwzxbcSJXMt15fdbNmgHH4TETywWxGM3uMf-tb9QROi8PPWoVCM3cTrymnWmzqppcvO_yczYqaLJ2JkBFuAAgp7ahM8dKUzlmiU3vLpvCPuXcLXOpQZPm4WCaVlZ5T8QztTa9qdFKHAVnv_opVulZQnE'

// {
//   "access_token": "v2.local.m4xW-ZU55tyF4OGRnRgzNuUqXGrEXY5F4AUPIIQIXboEM9ZjgA4ZVyIisqaDwCcTgZAs7aonPkQeDR2KbvgIeZz4A8CiSVYWl8bC0noh-7f9vkwfNYoHZhPJQfpCXd7xuegcQ-4qMucaINm7_iTix0haljAKHnceM6MEBdYVpKjzS3eqzXSwh9o8O1xIxvqzZhxEImRQRwUU6jQsE7XZt3Vrc9GzKIBsuoIEQVL90MQrjjirbErbnY28yJiwaY_MCx9qtxc9uUHxdVy5WenSyv6xnny4yNznAO-udGYHOTP9oL2U1USNxnwHKX5ppoaK9VwM0wMAr68FywfJM9cTetLzM4I",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-05-07T17:11:14.824500Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.m4xW-ZU55tyF4OGRnRgzNuUqXGrEXY5F4AUPIIQIXboEM9ZjgA4ZVyIisqaDwCcTgZAs7aonPkQeDR2KbvgIeZz4A8CiSVYWl8bC0noh-7f9vkwfNYoHZhPJQfpCXd7xuegcQ-4qMucaINm7_iTix0haljAKHnceM6MEBdYVpKjzS3eqzXSwh9o8O1xIxvqzZhxEImRQRwUU6jQsE7XZt3Vrc9GzKIBsuoIEQVL90MQrjjirbErbnY28yJiwaY_MCx9qtxc9uUHxdVy5WenSyv6xnny4yNznAO-udGYHOTP9oL2U1USNxnwHKX5ppoaK9VwM0wMAr68FywfJM9cTetLzM4I'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
